/** Display cash-drawer timestamps in Chile time, even if the PC is set to UTC. */
export const TZ_CHILE = 'America/Santiago';

export function formatHoraChile(value) {
    if (!value) return '';
    const d = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(d.getTime())) return '';
    return d.toLocaleTimeString('es-CL', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
        timeZone: TZ_CHILE,
    });
}

/** Calendar day in Chile as YYYY-MM-DD. */
export function hoyChileYmd(now = new Date()) {
    const parts = new Intl.DateTimeFormat('en-CA', {
        timeZone: TZ_CHILE,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    }).formatToParts(now);
    const get = (t) => parts.find((p) => p.type === t)?.value || '';
    return `${get('year')}-${get('month')}-${get('day')}`;
}

/** Full local day for datetime-local inputs: 00:00 through 23:59. */
export function rangoHoyChile(now = new Date()) {
    const ymd = hoyChileYmd(now);
    return { desde: `${ymd}T00:00`, hasta: `${ymd}T23:59` };
}

/**
 * Fixed-width Chile timestamp for tables: `DD-MM-YYYY HH:mm`.
 * Date-only values stay as a date so UTC midnight does not shift the clock.
 */
export function formatFechaHoraLista(value) {
    if (!value) return '';
    if (!(value instanceof Date)) {
        const raw = String(value).trim();
        const dateOnly = raw.match(/^(\d{4})-(\d{2})-(\d{2})$/);
        if (dateOnly) return `${dateOnly[3]}-${dateOnly[2]}-${dateOnly[1]}`;
    }
    const d = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(d.getTime())) return '';
    const parts = new Intl.DateTimeFormat('en-CA', {
        timeZone: TZ_CHILE,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
    }).formatToParts(d);
    const get = (t) => parts.find((p) => p.type === t)?.value || '';
    let hour = get('hour');
    if (hour === '24') hour = '00';
    return `${get('day')}-${get('month')}-${get('year')} ${hour}:${get('minute')}`;
}

export function formatFechaHoraChile(value) {
    if (!value) return '';
    const d = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(d.getTime())) return '';
    return d.toLocaleString('es-CL', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
        timeZone: TZ_CHILE,
    });
}
